import React from 'react';
import { RAuthProvider } from './r-auth.provider';
import { RAuth } from './r-auth.view';

type RAuthFeatureProps = {
   captchaKey: string | null;
};

export const RAuthFeature: React.FC<RAuthFeatureProps> = () => {
   return (
      <RAuthProvider>
         <RAuth />
      </RAuthProvider>
   );
};
